import * as t from "io-ts";
import * as cargoViews from "./cargo-view";
import * as routes from "./routes";
import { routeT } from "./routes";
import nullable from "./nullable";
export const createArchivedRoutesT = ({ decimal, dateTime, }) => {
    const { cargoViewT } = cargoViews.createCargoViewTypes({
        decimal,
        dateTime,
    });
    const archivedRoutesResponseT = t.strict({
        routes: t.array(routeT),
        cargoViews: t.array(cargoViewT),
        routeViews: routes.routeViewModelsT,
    });
    return { routeT, archivedRoutesResponseT };
};
export { routeT };
export const { archivedRoutesResponseT } = createArchivedRoutesT({
    decimal: t.string,
    dateTime: t.string,
});
export const routeToArchiveSuggestionT = nullable(t.strict({
    routeId: t.string,
    routeRef: nullable(t.string),
}));
//# sourceMappingURL=archived-routes.js.map